import type { OpportunityStage, OpportunityStatus } from '@catalyst-psa/shared';
import {
  OPPORTUNITY_STAGE_LABELS,
  OPPORTUNITY_STATUS_LABELS,
} from '@catalyst-psa/shared';

import type { Badge } from '../../components/ui/Badge.js';

type BadgeTone = NonNullable<Parameters<typeof Badge>[0]['tone']>;

export const OPPORTUNITY_STAGE_TONES: Record<OpportunityStage, BadgeTone> = {
  lead: 'gray',
  business_discussion: 'blue',
  quoted: 'amber',
  committed: 'blue',
  won: 'green',
};

export const OPPORTUNITY_STATUS_TONES: Record<OpportunityStatus, BadgeTone> = {
  open: 'blue',
  order_approved: 'amber',
  won: 'green',
  lost_competitor: 'red',
  lost_project_cancelled: 'red',
};

export { OPPORTUNITY_STAGE_LABELS, OPPORTUNITY_STATUS_LABELS };
